module.exports = __webpack_public_path__ + "static/preview_description-87184266e6269e0ee88d6abb289953fb.png";